import Splide from "@splidejs/splide";

window.addEventListener('DOMContentLoaded', function(){

    let elms = document.querySelectorAll('.basic-google-reviews .splide');

    if(elms){
        
        let options = {
            type: 'loop',
            perPage: 3,
            perMove: 1,
            gap: '4rem',
            arrows: false,
            pagination: true,
            autoplay: true,
            interval: 5000,
            speed: 1200,
            breakpoints:{
                660:{
                    perPage: 1,
                    padding: {
                        left: '15%',
                        right: '15%'
                    },
                    speed: 600
                }
            }
        }

        for ( var i = 0; i < elms.length; i++ ) {
            
            new Splide( elms[ i ], options ).mount();

            let cards = elms[ i ].querySelectorAll('.review');

            Array.from(cards).forEach( card => card.addEventListener('click', handle_click ) );

        }

    }

    function handle_click(e){
        
        if( e.target.classList.contains( 'bgr-read-more' ) ){
            e.currentTarget.querySelector('.excerpt').style.display = "none"
            e.currentTarget.querySelector('.full').style.display = "block"
        }
        
        if( e.target.classList.contains( 'bgr-read-less' ) ){
            e.currentTarget.querySelector('.excerpt').style.display = "block"
            e.currentTarget.querySelector('.full').style.display = "none"
        }

    }


})